import {
    ConversationReadyToLoadStitch,
    ConversationReadyToLoadStitchName,
} from 'owa-mail-store-actions';
import { lazyUpdateLoadedConversation } from 'owa-mail-reading-pane-store';
import { subscribe } from 'satcheljs/lib/legacy/stitch';

export default function subscribeToUpdateLoadedConversationStitch() {
    subscribe<ConversationReadyToLoadStitch>(
        ConversationReadyToLoadStitchName,
        lazyUpdateLoadedConversation.importAndExecute
    );
}
